import { calculation } from "@/method";

export default function compute(data) {
    const adrName = ['m_adr', 'lastm_adr', 'y_adr', 'lasty_adr'];

    // ADR
    adrName.forEach(name => {
        const RN = name.split('_')[0] + '_rn';
        const REV = name.split('_')[0] + '_rev';
        data.forEach((item, i) => {
            data[i][name] = calculation(item[REV], item[RN]);
        });
    });

    // Variance
    data.forEach((item, i) => {
        data[i].varm_rn = calculation(item.m_rn - item.lastm_rn, item.lastm_rn, 4);
        data[i].varm_adr = calculation(item.m_adr - item.lastm_adr, item.lastm_adr, 4);
        data[i].varm_rev = calculation(item.m_rev - item.lastm_rev, item.lastm_rev, 4);
        data[i].vary_rn = calculation(item.y_rn - item.lasty_rn, item.lasty_rn, 4);
        data[i].vary_adr = calculation(item.y_adr - item.lasty_adr, item.lasty_adr, 4);
        data[i].vary_rev = calculation(item.y_rev - item.lasty_rev, item.lasty_rev, 4);
    });
    return data
}


// WEBPACK FOOTER //
// ./src/components/table/4.0/4-4/compute.js